export default (that) => [
  {
    text: that.$l('btn_view_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_quotation') || '产品报价',
    icon: 'el-icon-coin',
    menuType: 'quotation',
    allow: 'A',
    divided: true,
  },
  {
    text: that.$l('btn_cancel_select') || '取消选样',
    icon: 'el-icon-delete',
    allow: 'B',
    menuType: 'cancel',
    disabled: ({ devTrackingStatus }) => 'D' == devTrackingStatus,
  },
  {
    text: that.$l('btn_proofing_arrangement') || '打样安排',
    icon: 'el-icon-box',
    allow: 'C',
    menuType: 'proofing',
  },
  {
    text: that.$l('btn_sending_arrangement') || '寄样安排',
    icon: 'el-icon-truck',
    allow: 'D',
    menuType: 'sending',
  },
  {
    text:  that.$l('btn_customer_order') || '客人下单',
    icon: 'el-icon-circle-check',
    allow: 'F',
    menuType: 'order',
    divided: true,
  },
]
